import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { RecentSearchQueryView } from "./RecentSearchQueryView/RecentSearchQueryView";
import { ResultSectionLayout } from "../../ResultSectionLayout/ResultSectionLayout";
import { GlobalSearchTermModel } from "client/Api/TitleBar/GlobalSearch/globalSearch";

export type RecentSearchListViewProps = {
	recentSearchQueries: readonly GlobalSearchTermModel[];
	navigationStartingIndex: number;
	onDelete: (id: number) => void;
	onClear: () => void;
	onSearch: (searchTerm: string) => void;
	tabbableIndex: number | null;
};

export const RecentSearchListView = (props: RecentSearchListViewProps): ReactElement => {
	const {
		recentSearchQueries,
		navigationStartingIndex,
		onDelete,
		onClear,
		onSearch,
		tabbableIndex
	} = props;

	return(
		<ResultSectionLayout
			trackingId="recent-search-list"
			title={localize("_RecentSearches")}
			onClearAll={() => onClear()}
		>
			<ResultSectionLayout.List>
				{
					recentSearchQueries.map((
						item: GlobalSearchTermModel,
						index: number
					): ReactElement => {
						const itemIndex: number = index + navigationStartingIndex;

						return (
							<RecentSearchQueryView
								tabIndex={itemIndex === tabbableIndex ? 0 : -1}
								item={item}
								itemIndex={itemIndex}
								key={item.id}
								onDelete={onDelete}
								onSearch={onSearch}
							/>
						);
					})
				}
			</ResultSectionLayout.List>
		</ResultSectionLayout>
	);
};
RecentSearchListView.displayName = "RecentSearchListView";